<template>
    <div class="volume-control" @mouseenter="expanded = true" @mouseleave="expanded = false">
        <button @click="$emit('toggle-mute')" class="icon-btn">
            <svg v-if="volume > 0.5" width="32" height="32" viewBox="0 0 24 24" fill="currentColor"> <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/> </svg>
            <svg v-else-if="volume > 0" width="32" height="32" viewBox="0 0 24 24" fill="currentColor"> <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/> </svg>
            <svg v-else width="32" height="32" viewBox="0 0 24 24" fill="currentColor"> <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/> </svg>
        </button>
        <div class="volume-slider-wrap">
            <input
                @click.stop
                type="range"
                class="volume-slider"
                min="0"
                max="1"
                step="0.1"
                :value="volume"
                @input="$emit('update:volume', Number($event.target.value))"
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'VolumeControl',
    props: {
        volume: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            expanded: false
        }
    }
}
</script>

<style lang="scss" scoped>
.volume-control {
    display: flex;
    align-items: center;
    gap: 0;

    &:hover .volume-slider-wrap {
        width: 80px;
        opacity: 1;
        margin-left: 8px;
    }
}

.volume-slider-wrap {
    width: 0;
    opacity: 0;
    transition: width 0.25s ease, opacity 0.2s ease, margin-left 0.25s ease;
    display: flex;
    align-items: center;
}

.volume-slider {
    width: 80px;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
    outline: none;
    cursor: pointer;
    -webkit-appearance: none;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
            transform: scale(1.2);
        }
    }

    &::-moz-range-thumb {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
        border: none;
        transition: transform 0.2s;

        &:hover {
            transform: scale(1.2);
        }
    }
}
</style>
